import React, { FC, useEffect, useState } from 'react'
import { useTheme } from 'styled-components'
import {
  BigAlert, Button, ModalVariables,
} from '../../components'
import { AlertProps, useUi } from '../../context/ui.context'
import {
  Container,
  WelcomeRow,
  HomeContent,
  HomeBottomGrid,
  WelcomeTitle,
  ErrorContainer,
  ErrorText,
} from './styles'
import {
  Diagrams,
  NavComponents,
  GettingStarted,
  Services,
} from './components'
import { GettingStartedStyles } from './components/gettingStarted/styles'
import { useQueryParam, StringParam } from 'use-query-params';
import { useAuth } from '../../context/user.context'
import { useTranslation } from 'react-i18next'
import AlertIcon from './error.svg'
import { useNavigate } from 'react-router-dom'
import { billingService } from '../../api'
import config from '../../config'
import {Helmet} from "react-helmet";
import { permissionSurfaces, usePermission, usePermissionDecision } from '../../permissions';

const GETTING_STARTED_ALERT_HIDDEN_KEY = 'ocp_getting_started_alert_hidden'

const HomePage:FC = () => {
  const {user} = useAuth()
  const [t] = useTranslation()
  const navigate = useNavigate()
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [invoiceId, setInvoiceId] = useQueryParam('invoiceId', StringParam);
  const [invoice, setInvoice] = useState<any>()
  const [remainingInfo, setRemainingInfo] = useState<any>({})
  const [showGettingStartedAlert, setShowGettingStartedAlert] = useState<boolean>(() => (
    localStorage.getItem(GETTING_STARTED_ALERT_HIDDEN_KEY) !== 'true'
  ))
  const {setViewModalComplete, setActiveAnimationComplete} = useUi()
  const { mergeEntityPermissions } = usePermission()
  const canViewSummary = usePermissionDecision(permissionSurfaces.detailActions.summaryView).allowed
  const canViewBillingShortcut = usePermissionDecision(permissionSurfaces.detailActions.summaryBillingShortcut).allowed
  const activeClientId = user?.user?.active_client
  const closeModal = () => {
    setViewModal(false)
    setActiveAnimation(false)
  }
  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
  }
  const openModal = (modal:any) => {
    setModalType(modal)
    setViewModal(true)
    setActiveAnimation(true)
  }
  const closeGettingStartedAlert = () => {
    localStorage.setItem(GETTING_STARTED_ALERT_HIDDEN_KEY, 'true')
    setShowGettingStartedAlert(false)
  }
  const checkBillingInfo = async () => {
    try {
      const res = await billingService.getRemainingInfo()
      mergeEntityPermissions('billing', res.data, 'Merged home billing shortcut permissions')
      setRemainingInfo(res.data)
    } catch {
      setRemainingInfo({})
    }
  }
  const showVerificationAlert = !user?.user?.active_client || user?.requires_email_verification
  const openVerification = () => {
    if (!user?.user?.active_client) {
      navigate('/complete-registration')
      return
    }

    setViewModalComplete(true)
    setActiveAnimationComplete(true)
  }
  useEffect(() => {
    setRemainingInfo({})

    if (canViewBillingShortcut) {
      void checkBillingInfo()
    }

    if(invoiceId){
      openModal('payment-success')
      setInvoice(invoiceId)
      setInvoiceId(null)
    }
  },[activeClientId, canViewBillingShortcut, invoiceId])
  return (
    <Container data-test-id='home-page'>
      <GettingStartedStyles/>
      {/* <Helmet>
        <script src="https://script.tapfiliate.com/tapfiliate.js" type="text/javascript" async></script>
        <script type="text/javascript">
          {`(function(t,a,p){t.TapfiliateObject=a;t[a]=t[a]||function(){ (t[a].q=t[a].q||[]).push(arguments)}})(window,'tap');

          tap('create', '47976-36852c', { integration: "javascript" });
          tap('customer', ${user?.user?.email});`}
        </script>
      </Helmet> */}
      <WelcomeRow>
        <WelcomeTitle>
          {t("WELCOME")} {user?.user?.first_name || ''}!
        </WelcomeTitle>
      </WelcomeRow>
      <HomeContent data-test-id='home-content'>
        {showGettingStartedAlert &&
          <BigAlert
            severity={t("GETTING_STARTED_ALERT")}
            message={t("GETTING_STARTED_ALERT_DESC")}
            deleteItem={closeGettingStartedAlert}
            onClick={() => window.open(config.docs_url)}
          />
        }
        {showVerificationAlert &&
          <ErrorContainer data-test-id='home-verification-alert' isError={true}>
            <div style={{display:'flex', alignItems:'center', gap:'6px'}}>
              <img src={AlertIcon} alt="" aria-hidden="true"/>
              <ErrorText>
                {t("ERROR_VERIFICATION_MESSAGE")}
              </ErrorText>
            </div>
            <Button
              title={!user?.user?.active_client ? t("GO_TO_CREATE_CLIENT") : t("VERIFY_EMAIL")}
              onClick={openVerification}
              size='display'
              variant='primary'
              customStyles={{width:'175px'}}
            />
          </ErrorContainer>
        }
        {canViewBillingShortcut && remainingInfo?.reached_credit_limit &&
          <ErrorContainer style={{marginTop:'20px'}} isError={true}>
            <div style={{display:'flex', alignItems:"center", gap:'6px'}}>
              <img src={AlertIcon}/>
              <ErrorText>{t("ERROR_OUT_OF_CRADIT")}</ErrorText>
            </div>
            <Button
              title={t("GO_TO_BILLING")}
              onClick={() => navigate('/billing/overview')}
              size='small'
              variant='primary'
            />
          </ErrorContainer>
        }
        {canViewSummary ? <Diagrams/> : null}
        <NavComponents/>
        <Services/>
        <HomeBottomGrid>
          <GettingStarted/>
        </HomeBottomGrid>
      </HomeContent>
      <ModalVariables
        modalType={modalType}
        closeModalCancel={closeModalCancel}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        alertSubTitle={invoice}
      />
    </Container>
  )
}

export default HomePage
